import DefaultApi from '.';
import TreeObject from './TreeObject';
import fetch from './fetch';

export default class StructureApi extends DefaultApi {
    constructor(...args) {
        super(...args);

        // search method is implemented
        this.searchEnabled = true;
    }

    _init_root() {
        // called by constructur, set basic attributes
        this.apiType = 'structure';
        if (window.structure_path && !Array.isArray(window.structure_path)) {
            return new TreeObject(this, window.structure_path);
        }
        return DefaultApi._init_root.call(this);
    }

    _extractActiveObject() {
        let tempTreeObject = this.root;
        // go down the path until we have either the active object or its parent
        while (!tempTreeObject.active && tempTreeObject.children.length === 1) {
            tempTreeObject = tempTreeObject.children[0];
        }
        // iterate the children if we don't have the active object yet
        if (!tempTreeObject.active) {
            tempTreeObject.children.some((child) => {
                if (child.active) {
                    tempTreeObject = child;
                    return true;
                }
                if (child.isCategory) {
                    // child may be a category containing grandchildren
                    return child.children.some((grandchild) => {
                        if (grandchild.active) {
                            tempTreeObject = grandchild;
                            return true;
                        }
                        return false;
                    });
                }
                return false;
            });
        }
        return tempTreeObject;
    }

    /* eslint-disable class-methods-use-this,no-unused-vars */
    /**
     * Structure Navigation JSON representation is complete, no expansion needed,
     * but TreeNode initialization
     * @param {*} jsonObject
     */
    expandData(treeObject) {
        // call handler with object to initialize the child TreeObjects
        treeObject.createChildren();
    }
    /* eslint-enable class-methods-use-this,no-unused-vars */

    updateTree() {
        return new Promise((resolve, reject) => {
            fetch(`${window.PORTAL_URL}/@@organisation_navigation`, {
                credentials: 'same-origin',
                headers: { Accept: 'application/json' },
            }).then((response) => {
                if (!response.ok) {
                    // we want to handle 2xx responses only
                    throw Error(response.statusText);
                }
                return response.json();
            }).then((data) => {
                // create a new root with the fetched data
                this.root = new TreeObject(this, data);
                // get the new activeObject by syncing on the old active object (uses this.root)
                this.activeObject = this.getSyncedObject(this.activeObject);
                resolve();
            }).catch((error) => {
                reject(error);
            });
        });
    }

    /**
     *
     * @param {*} treeObject
     * @returns
     */
    getSyncedObject(treeObject) {
        let tempObject = this.root;
        // We walk down the breadcrumbs only as these are the objects that can be opened by the user
        treeObject.breadcrumbs.slice(1).every((pathObject) => {
            // get the child (with init if neccessary)
            const nextTempObject = tempObject.getChild(pathObject.id);
            if (nextTempObject) {
                tempObject = nextTempObject;
                return true;
            }
            // paths are out of sync here, break
            return false;
        });
        return tempObject;
    }

    /**
     * Search titles in the treeObject structures
     * @param {*} str
     * @returns Array
     */
    search(searchString) {
        const treeObject = this.root;
        const queue = [...treeObject.children];
        const results = [];
        const { lang } = document.documentElement;

        /**
         * Check if a given string contains the searchString
         * @param {String} string
         * @returns {Boolean}
         */
        const hit = (string) => string.toUpperCase().includes(searchString.toUpperCase());

        while (queue.length) {
            const object = queue[0];
            queue.push(...object.children);
            queue.shift();

            const url = object.url;
            // don't search in categories or objects without a target
            if (object.isCategory || typeof url === 'undefined' || url.length === 0) {
                // eslint-disable-next-line no-continue
                continue;
            }
            if (
                hit(object.title)
                || hit(object.id)
            ) {
                results.push(object);
            }
        }
        return results.sort((a, b) => a.title.localeCompare(b.title, lang));
    }
}
